import {ComponentProps, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import * as api from "../../apis/sample";
import * as productApi from "../../apis/product";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import Divider from "../../components/Divider";
import {Button, Input, message, Popconfirm, Space} from "antd";
import useFormModal from "../../utils/useFormModal";
import ModifyModal from "./component/ModifyModal";
import {useRequest} from "ahooks";
import ProductSelectModal from "../../components/ProductSelectModal";
import UploadModal from "../../components/UploadModal";
import withAuth from "../../utils/withAuth";


const AddButton = withAuth('add', Button);
const ImportButton = withAuth('importExcel', Button);

function Sample(props: ComponentProps<any>) {

    const {tableProps, form, search, refresh} = useAntTable(api.getSamples, {});
    const [productSelectModalVisible, setProductSelectModalVisible] = useState(false);
    const [importExcelModalVisible, setImportExcelModalVisible] = useState(false);

    const {modalProps, setVisible} = useFormModal({
        onOk(record: any) {
            runSubmit(record);
        }
    });
    const {loading: loadingImport, run: runImport} = useRequest(api.importSamples, {
        manual: true,
        onSuccess(res) {
            message.success('上传成功');
            setImportExcelModalVisible(false);
            refresh();
        }
    })
    const {loading: loadingAdd, run: runAdd} = useRequest(api.addSamples, {
        manual: true,
        onSuccess(res) {
            message.success('添加成功');
            refresh();
        }
    })

    const {loading: loadingSubmit, run: runSubmit} = useRequest(api.updateSample, {
        manual: true,
        onSuccess() {
            setVisible(false);
            refresh();
        }
    })
    const {loading: loadingDelete, run: runDelete} = useRequest(api.deleteSample, {
        manual: true,
        onSuccess() {
            refresh();
        }
    });

    const handleProductSelected = (keys?: Array<number>, records?: Array<any>) => {
        if (!records?.length) {
            message.error('请选择商品');
            return;
        }
        const products = records.map((p: any) => ({
            productId: p.id
        }));
        debugger
        runAdd(products);
        setProductSelectModalVisible(false);
    }

    const columns: StandardColumnsType = [
        {
            dataIndex: 'productCode',
            // key: 'productNumber',
            title: '商品编号'
        },
        {
            dataIndex: 'productAbbreviation',
            // key: 'abbreviation',
            title: '缩写'
        },
        {
            dataIndex: 'productName',
            // key: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'specification',
            // key: 'specifications',
            title: '规格'
        },
        {
            dataIndex: 'placeOrder',
            // key: 'placeOrder',
            title: '下单',
            render(v) {
                return !!v ? '是' : '否'
            }
        },
        {
            dataIndex: 'remark',
            // key: 'remainingAmount',
            title: '备注'
        },
        {
            dataIndex: 'operation',
            // key: 'operation',
            title: '操作',
            render(v: any, record: any) {
                return <Divider>
                    <a onClick={() => setVisible(true, record)}>编辑</a>
                    <Popconfirm title={'是否确认删除？'} onConfirm={() => runDelete(record.id)}>
                        <a style={{color: 'var(--danger-color)'}}>删除</a>
                    </Popconfirm>
                </Divider>
            }
        }
    ];
    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'product',
            key: 'product',
            title: '商品编号/名称',
            search: true
        },
        {
            dataIndex: 'placeOrder',
            key: 'placeOrder',
            title: '下单',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 10, text: '是'},
                    {value: 0, text: '否'},
                ]
            }
        },
    ];

    const toolbar = (
        <Space>
            <AddButton type={"primary"} onClick={() => setProductSelectModalVisible(true)}>新增</AddButton>
            <ImportButton type={'primary'} onClick={() =>  setImportExcelModalVisible(true)}>导入</ImportButton>
        </Space>
    )

    return <PageHeaderLayout>
        <StandardTable {...tableProps} form={form} search={search} columns={columns} toolbar={toolbar}
                       extSearchColumns={searchColumns}/>
        <ModifyModal {...modalProps}/>
        <ProductSelectModal open={productSelectModalVisible}
                            multiple
                            onComplete={handleProductSelected}
                            url={productApi.getAllProductsUrl}
                            onCancel={() => setProductSelectModalVisible(false)}/>
        <UploadModal title={'样品导入'} key={'sampleImport'}
                     onUpload={runImport}
                     open={importExcelModalVisible}
                     template={'/template/样品主档导入模板.xlsx'}
                     confirmLoading={loadingImport}
                     onCancel={() => setImportExcelModalVisible(false)}/>
    </PageHeaderLayout>
}

export default Sample
